import { Button } from "antd";
import { AuthCheck, AUTH_ACTIONS } from "authorization";
import { useStoreState } from "easy-peasy";
import React from "react";
import { Link, useRouteMatch } from "react-router-dom";

export default function NewUserButton({ ...props }) {
  const { abilities } = useStoreState((state) => state.auth);
  const match = useRouteMatch();
  const IsAuthorized = AuthCheck(
    abilities,
    AUTH_ACTIONS.NEW_RECORD,
    "Kullanıcı Listesi"
  );

  return (
    <Button disabled={!IsAuthorized}>
      <Link to={`${match.path}/yeni`}> Yeni Kullanıcı</Link>
    </Button>
  );
}
